import { getData, postData } from '../../../helpers/axiosHelper';
import { queryString } from '../../../utils/heap';

import { GPT_ENDPOINT } from '../consts';
import {
  IAnalyzeFeedRequestData,
  IAnalyzeFeedResponseData,
  ICreateGptJobRequestData,
  ICreateGptJobResponseData,
  ICreateGptJobTitlePreviewRequestData,
  ICreateGptJobTitlePreviewResponseData,
  IEditMyGptJobRequestData,
  IGetGptJobDetailsResponseData,
  IGetMyGptJobsResponseData,
} from '../types';

export const getMyGptJobs = async (): Promise<IGetMyGptJobsResponseData> => {
  const url = `${GPT_ENDPOINT}/myjobs`;
  return getData(url);
};

export const editGptJob = async (
  requestData: IEditMyGptJobRequestData
): Promise<void> => {
  const url = `${GPT_ENDPOINT}/jobs/${requestData.gptJobId}`;
  return postData(url, requestData.body);
};

export const getGptJobDetails = async (
  gptJobId: string
): Promise<IGetGptJobDetailsResponseData> => {
  const url = `${GPT_ENDPOINT}/details`;
  return getData(
    queryString.stringifyUrl({
      url,
      query: {
        gptJobId,
      },
    })
  );
};

export const analyzeFeed = async (
  requestData: IAnalyzeFeedRequestData
): Promise<IAnalyzeFeedResponseData> => {
  const url = `${GPT_ENDPOINT}/analyze`;
  return postData(url, requestData);
};

export const createGptJob = async (
  requestData: ICreateGptJobRequestData
): Promise<ICreateGptJobResponseData> => {
  const url = `${GPT_ENDPOINT}/title-optimization`;
  return postData(url, requestData);
};

export const createGptJobTitlePreview = async (
  requestData: ICreateGptJobTitlePreviewRequestData
): Promise<ICreateGptJobTitlePreviewResponseData> => {
  const url = `${GPT_ENDPOINT}/title-preview`;
  return postData(url, requestData);
};
